exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".control[data-v-3b6f5860]{box-sizing:content-box;width:48px;height:24px;line-height:24px;padding:0;text-align:center;background-color:var(--muted);font-family:var(--font-mono);cursor:pointer;outline:none;user-select:none;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3b6f5860&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InfoControl.vue
// module id = 7
// module chunks = 0